const autoNgTemplateLoaderTemplate1 = require('./productItem.html');

angular.module('portainer.app').component('productItem', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  bindings: {
    model: '<',
    goTo: '<',
  },
});
